import { render, staticRenderFns } from "./cateAddStepper.vue?vue&type=template&id=f5b83aca&scoped=true"
import script from "./cateAddStepper.vue?vue&type=script&lang=js"
export * from "./cateAddStepper.vue?vue&type=script&lang=js"
import style0 from "./cateAddStepper.vue?vue&type=style&index=0&id=f5b83aca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b83aca",
  null
  
)

export default component.exports